<template>
  <v-card flat v-if="employee && Object.keys(employee).length > 0">
    <v-btn class="gray mb-n2 ml-2 mt-n1" text @click="$emit('backToList')">
      <v-icon>$sl-arrow-left</v-icon>Tillbaka</v-btn
    >
    <v-card-title>
      <h5>{{ employee | fullName }}</h5>
    </v-card-title>
    <v-card-actions class="mt-n4">
      <v-btn color="secondary" @click="personClick(employee)">
        <v-icon>$sl-user2</v-icon>
        Visa personprofil
      </v-btn>
    </v-card-actions>
    <v-card-text>
      <v-row>
        <v-col sm="12" md="6"
          ><h6>ADRESS</h6>
          <p class="body-1">
            {{ employee.address || '' }}
            <br />
            {{ employee.zip | formatZip }} {{ employee.city || '' }}
          </p>
        </v-col>
        <v-col sm="12" md="6"
          ><h6>KONTAKTINFORMATION</h6>
          <v-row class="mt-n5">
            <v-col cols="5">
              <p class="button semi-bold">mobiltelefon</p>
            </v-col>
            <v-col cols="7">
              <p class="body-1 mt-n1">{{ employee.mobilephone || '' }}</p>
            </v-col>
          </v-row>
          <v-row class="mt-n8">
            <v-col cols="5">
              <p class="button semi-bold">e-postadress</p>
            </v-col>
            <v-col cols="7">
              <p class="mt-n1 body-1">
                <a v-if="employee.email" :href="'mailto:' + employee.email">{{ employee.email || '' }}</a>
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h6 class="mt-n2">MINA SIDOR</h6>

      <v-btn color="secondary" @click="$emit('show-edit')" :disabled="!canUpdate">
        <v-icon>$sl-edit</v-icon>
        ändra
      </v-btn>
      <v-row class="mt-1">
        <v-col sm="2" md="2">
          <p class="button semi-bold">Rollbeskrivning</p>
        </v-col>
        <v-col sm="10" md="5">
          <p class="body-1">{{ employee.roledescription }}</p>
        </v-col>
        <v-col sm="0" md="5"></v-col>
      </v-row>

      <v-row class="mt-n4">
        <v-col sm="2" md="2">
          <p class="button semi-bold">Roller</p>
        </v-col>
        <v-col sm="10" md="5">
         <p class="body-1" v-if="selectedCompany && !selectedCompany.hasDepartments">{{ employee.role }}</p> 
          <div class="body-1 mt-4" v-else>
            <p>{{ employee.isAdministrator ? employee.isAdministrator :'' }}</p>
            <div v-for="(r, index) in rolebyComma(employee.role)" :key="index">
              <p class="mt-n4">
                {{ index }} ({{ r }})
              </p>
            </div>
          </div>
        </v-col>
        <v-col sm="0" md="5"></v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {CanIDo} from '@/components/mixins'
export default {
  props: {
    employee: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    }
  },
  mixins:[CanIDo],

    computed: {
    ...mapGetters('company', ['selectedCompany'])
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('employment', 'update');
    },
  },

  methods: {
    personClick(emp) {
      const eId = emp.employedId
      this.$nextTick(() => this.$router.push({name: 'PersonDetail', params: {id: eId}}).catch(() => {}))
    },
    rolebyComma(roles) {
      let rols = []
      roles.forEach(d => {
        d.role.forEach(r => {
          rols.push({role: r, name: d.department.name})
        })
      })
      const outputObj = rols.reduce((accum, dep) => {
        if (!accum[dep.role]) {
          accum[dep.role] = dep.name
        } else {
          accum[dep.role] += ', ' + dep.name
        }

        return accum
      }, {})

      return outputObj
    }
  }
}
</script>

<style lang="scss" scoped>
</style>